import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { ResponsiveImage } from '../ResponsiveImage';
import { CtaShell } from '../CtaShell';
import {
  StyledCard,
  CardTitle,
  CardContent,
  CardBody,
  CardImageContainer,
  CardButtonContainer,
} from './styles';

export const SlideDownCard = ({
  header,
  description,
  button,
  image,
  onClick,
  buttonVariant = 'primary',
}) => {
  return (
    <StyledCard>
      <CardImageContainer>
        <ResponsiveImage
          src={image.src}
          alt={image.alt}
          width={280}
          height={210}
        />
      </CardImageContainer>

      <CardContent>
        <CardTitle>{header}</CardTitle>
        <CardBody>{description}</CardBody>
      </CardContent>

      {button && (
        <CardButtonContainer $alignment={button.alignment}>
          <CtaShell
            alignment={button.alignment}
            fullWidth={button.fullWidth}
            fullWidthMobile={button.fullWidthMobile}
            fullWidthDesktop={button.fullWidthDesktop}
          >
            <LinkButton
              verticalPadding={1}
              horizontalPadding={8}
              variant={buttonVariant}
              href={button.target}
              alignment={button.alignment}
              onClick={onClick}
              minWidth={90}
              fullWidth={button.fullWidth}
              fullWidthMobile={button.fullWidthMobile}
              fullWidthDesktop={button.fullWidthDesktop}
            >
              {button.text}
            </LinkButton>
          </CtaShell>
        </CardButtonContainer>
      )}
    </StyledCard>
  );
};

SlideDownCard.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.node,
  button: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    alignment: PropTypes.oneOf(['left', 'center', 'right']),
  }),
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  buttonVariant: PropTypes.string,
};
